import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface BillingDetailsCardProps {
  children: ReactNode;
  className?: string;
}

export const BillingDetailsCard = ({
  children,
  className,
}: BillingDetailsCardProps) => (
  <div
    className={classNames(
      "bg-primary border-primary rounded-lg border px-8 py-7",
      className,
    )}
  >
    {children}
  </div>
);
